import { sendGTMEvent } from '@next/third-parties/google';
import { readCookieConsent } from '@/lib/cookie-consent';

const MAX_ANALYTICS_LABEL_LENGTH = 120;

export interface LeadConversionDetail {
  formName: string;
  leadSource: 'contact_page' | 'sales_callback';
  leadTopic?: string;
  destinationPath: string;
}

function cleanAnalyticsLabel(value: string | undefined): string | undefined {
  const label = value?.replace(/\s+/g, ' ').trim();
  return label ? label.slice(0, MAX_ANALYTICS_LABEL_LENGTH) : undefined;
}

/** Pushes a confirmed lead only when the visitor has granted analytics consent. */
export function dispatchLeadConversion(detail: LeadConversionDetail): void {
  if (typeof window === 'undefined' || !readCookieConsent()?.analytics) return;

  const locale = window.location.pathname.split('/').filter(Boolean)[0];

  sendGTMEvent({
    event: 'generate_lead',
    page_path: window.location.pathname,
    page_location: `${window.location.origin}${window.location.pathname}`,
    page_title: document.title,
    ...(locale ? { page_locale: locale } : {}),
    form_name: cleanAnalyticsLabel(detail.formName),
    lead_source: detail.leadSource,
    lead_topic: cleanAnalyticsLabel(detail.leadTopic),
    conversion_destination: detail.destinationPath,
  });
}

/** Records API-confirmed OTP outcomes; never includes the number or code. */
export function dispatchOtpOutcome(
  event: 'otp_sent' | 'otp_verified',
  formName: string,
  method?: 'sms' | 'voice',
  resend?: boolean,
): void {
  if (typeof window === 'undefined' || !readCookieConsent()?.analytics) return;
  sendGTMEvent({
    event,
    page_path: window.location.pathname,
    page_location: `${window.location.origin}${window.location.pathname}`,
    page_title: document.title,
    form_name: cleanAnalyticsLabel(formName),
    ...(method ? { otp_method: method, otp_resend: Boolean(resend) } : {}),
  });
}
